import React, { Component } from 'react';
import { Link } from 'react-router-dom';


class Home extends Component {

  constructor(props) {
    super(props);

    this.state = {
      name: ''
    };
  }

  componentDidMount() {

    document.getElementsByClassName('nav-item')[2].classList.remove('active');
    document.getElementsByClassName('nav-item')[1].classList.remove('active');
    document.getElementsByClassName('nav-item')[0].classList.add('active');

    let date = new Date(),
        num = date.getDay(),
        dogPic = document.getElementsByClassName('todaysDog')[0],
        favicon = document.getElementsByClassName('favicon')[0],
        image = '',
        breed = '';
            
    switch(num) {
    
      case 0:
        image = 'https://vetstreet.brightspotcdn.com/dims4/default/93f75ad/2147483647/thumbnail/645x380/quality/90/?url=https%3A%2F%2Fvetstreet-brightspot.s3.amazonaws.com%2F69%2Fc5f6b0a71811e0a0d50050568d634f%2Ffile%2FAmerican-Eskimo-1-645mk070411.jpg';
        breed = "american eskimo dog";

      break;

      case 1:
        image = 'https://farm7.staticflickr.com/6114/6342537513_5b6f4b0c09_b.jpg';
        breed = "cardigan welsh corgi";
      break;
      
      case 2:
        image = 'https://upload.wikimedia.org/wikipedia/commons/6/6e/Laika01.jpg';
        breed = "west highland white terrier";

      break;
      
      case 3:
        image = 'https://upload.wikimedia.org/wikipedia/commons/4/48/Labrador_Retriever_DS.jpg';
        breed = "labrador retriever";

      break;
      
      case 4:
        image = 'https://farm5.staticflickr.com/4112/5170590074_714d36db83_b.jpg';
        breed = "golden retriever";
      
      break;
      
      case 5:
        image = 'https://upload.wikimedia.org/wikipedia/commons/7/72/Jack-Russell_Terrier.jpg';
        breed = "jack russell terrier";

      break;
      
      case 6:
        image = 'https://images.pexels.com/photos/191342/pexels-photo-191342.jpeg?cs=srgb&dl=chihuahua-dog-191342.jpg&fm=jpg';
        breed = "chihuahua";  
      break;

      default: 
      break;
      
    }

    this.setState({name: breed});
    this.setState({breed: breed.replace(/ /g, '_')});
    favicon.setAttribute("href", image);
    dogPic.style.backgroundImage = "url('" + image + "')";

    setTimeout(() => {
      dogPic.style.opacity = 1;
      document.getElementsByClassName('todaysDogSpinner')[0].style.display = "none";
    }, 100);
    

  }

  render() {
    return (
      <div className="content">
        <h2>Dog of the Day</h2>

        <div className="breed"><h3>{this.state.name}</h3></div>
        <Link to={`/Puppedia/dogs/${this.state.breed}`}>
          <div className="todaysDog">
            <i className="fa fa-2x fa-spinner todaysDogSpinner fa-spin"></i>
          </div>
        </Link>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js